import './App.css';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import Home from './Component/Home'
import About from './Component/About'
import Skills from './Component/Skills';
// import Skills from './views/Skills/Skills'
import Contact from './Component/Contact';
import Footer from './Footer';
import NavBar from './Component/NavBar';
import React from 'react';



function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <NavBar/>
     
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/about" element={<About/>}/>
        <Route path="/skills" element={<Skills/>}/>
        <Route path="/contact" element={<Contact/>}/>
        </Routes>
        <Footer/>
      </BrowserRouter>
    </div>
  );
}
export default App;